/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetTooltipDto
 */
export interface GetTooltipDto {
    /**
     * 
     * @type {string}
     * @memberof GetTooltipDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetTooltipDto
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof GetTooltipDto
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof GetTooltipDto
     */
    plText: string;
    /**
     * 
     * @type {string}
     * @memberof GetTooltipDto
     */
    enText: string;
}

/**
 * Check if a given object implements the GetTooltipDto interface.
 */
export function instanceOfGetTooltipDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "key" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "plText" in value;
    isInstance = isInstance && "enText" in value;

    return isInstance;
}

export function GetTooltipDtoFromJSON(json: any): GetTooltipDto {
    return GetTooltipDtoFromJSONTyped(json, false);
}

export function GetTooltipDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTooltipDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'key': json['key'],
        'description': json['description'],
        'plText': json['plText'],
        'enText': json['enText'],
    };
}

export function GetTooltipDtoToJSON(value?: GetTooltipDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'key': value.key,
        'description': value.description,
        'plText': value.plText,
        'enText': value.enText,
    };
}

